import { FunctionComponent } from 'react';
import styles from './FancyLabel.module.scss';
import classNames from 'classnames';

interface FancyLabelProps {
  visualType?: 'default' | '1';
  text: string | React.ReactElement;
  className?: string;
}

const FancyLabel: FunctionComponent<FancyLabelProps> = ({ visualType = 'default', text, className }) => {
  return (
    <div className={classNames(styles['label'], styles[`label--visual-type-${visualType}`], className)}>
      <p className={classNames(styles['label__text'], 'text text--caption text--bold-2')}>{text}</p>

      <svg className={styles['label__decor-1']} width="16" height="16" viewBox="0 0 16 16">
        <path d="M16 16C16 7.16345 8.83656 0 0 0H16V16Z" fill="var(--brand-orange-600)" />
      </svg>

      <svg className={styles['label__decor-2']} width="16" height="16" viewBox="0 0 16 16">
        <path d="M16 16C16 7.16345 8.83656 0 0 0H16V16Z" fill="var(--brand-orange-600)" />
      </svg>
    </div>
  );
};

export default FancyLabel;
